import type { LucideIcon } from "lucide-react"
import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

export function EmptyState({ icon: Icon, title, description, action, size = "default", className }: {
  icon: LucideIcon
  title: string
  description?: string
  action?: ReactNode
  size?: "sm" | "default"
  className?: string
}) {
  if (size === "sm") {
    return (
      <div className={cn("flex flex-col items-center justify-center gap-2 rounded-2xl border border-dashed px-6 py-10 text-center", className)}>
        <Icon className="size-6 text-muted-foreground/50" />
        <p className="text-sm font-semibold">{title}</p>
        {description && <p className="max-w-sm text-xs leading-relaxed text-muted-foreground">{description}</p>}
        {action}
      </div>
    )
  }
  return (
    <div className={cn("flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed bg-muted/20 px-6 py-14 text-center", className)}>
      <span className="flex size-14 items-center justify-center rounded-2xl bg-primary/10 text-primary"><Icon className="size-7" /></span>
      <div>
        <p className="font-display text-xl font-extrabold">{title}</p>
        {description && <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-muted-foreground">{description}</p>}
      </div>
      {action}
    </div>
  )
}
